export const siteName = '黑料一区';

export const tickerUpdates = [
  { time: '12:04', text: '综艺剪辑争议事件脉络补齐第 5 个节点' },
  { time: '11:37', text: '代言反噬复盘更新品牌方回应时间线' },
  { time: '11:02', text: '搬运链条调查新增 3 条账号路径对照' },
  { time: '10:26', text: '关键词追踪：本周热词「剪辑叙事」升幅明显' },
  { time: '09:48', text: '合集索引「事件复盘」第 46 篇归档完成' },
  { time: '09:15', text: '社区新增 128 条讨论，热门线索进入复核' },
];

export const quickEntries = [
  { label: '最新更新', href: '#updates' },
  { label: '事件脉络', href: '#timeline' },
  { label: '合集索引', href: '#collections' },
  { label: '社区讨论', href: '#community' },
];

export const navItems = [
  { label: '精选深挖', href: '#featured' },
  { label: '合集索引', href: '#collections' },
  { label: '事件脉络', href: '#timeline' },
  { label: '实时更新', href: '#updates' },
  { label: '分区索引', href: '#topics' },
  { label: '社区讨论', href: '#community' },
];

export const heroEntries = [
  { label: '最新更新', desc: '今日 6 条', icon: 'ri-flashlight-line', href: '#updates' },
  { label: '事件脉络', desc: '进行中 4 起', icon: 'ri-route-line', href: '#timeline' },
  { label: '合集索引', desc: '归档 165 篇', icon: 'ri-stack-line', href: '#collections' },
  { label: '社区讨论', desc: '新增 128 条', icon: 'ri-chat-3-line', href: '#community' },
];

export const heroStats = [
  { value: '2,860', label: '时间线节点' },
  { value: '165', label: '归档合集' },
  { value: '48', label: '追踪事件' },
  { value: '12.6k', label: '社区成员' },
];

export const featuredDigs = [
  {
    id: 1,
    tag: '节目机制',
    title: '剪辑如何制造冲突：一档综艺的叙事操控拆解',
    summary: '从素材选取、配乐铺陈到字幕引导，逐层还原一档节目如何在 90 分钟里把控观众的情绪走向。',
    image:
      'https://readdy.ai/api/search-image?query=Editorial%20concept%20image%20of%20scattered%20film%20strips%20and%20timeline%20markers%20on%20a%20warm%20paper%20desk%2C%20soft%20natural%20light%2C%20muted%20amber%20and%20vermilion%20tones%2C%20abstract%20investigative%20mood%2C%20minimal%20clean%20composition%2C%20high%20detail&width=1200&height=675&seq=heiliaoyiqu-story-01&orientation=landscape',
    readTime: '18 分钟深读',
    date: '09.08',
    views: '3.2 万',
  },
  {
    id: 2,
    tag: '品牌舆情',
    title: '72 小时反噬曲线：一次代言翻车的完整时间线',
    summary: '把预热、发酵、失控、止损四个阶段摊开，看清每一个转折点上，究竟是谁在推动风向。',
    image:
      'https://readdy.ai/api/search-image?query=Editorial%20concept%20image%20of%20a%20stylized%20rising%20and%20falling%20line%20chart%20drawn%20on%20warm%20textured%20paper%20with%20brass%20pins%2C%20soft%20daylight%2C%20muted%20terracotta%20and%20ochre%20palette%2C%20abstract%20public%20opinion%20timeline%20theme%2C%20minimal%20clean%20composition%2C%20high%20detail&width=1200&height=675&seq=heiliaoyiqu-story-02&orientation=landscape',
    readTime: '22 分钟深读',
    date: '09.06',
    views: '4.7 万',
  },
  {
    id: 3,
    tag: '内容分发',
    title: '搬运链条调查：同一批账号为何总能抢占热榜',
    summary: '追踪一条内容从原创到二次分发的完整路径，理清流量倾斜背后被忽略的规则与节点。',
    image:
      'https://readdy.ai/api/search-image?query=Editorial%20concept%20image%20of%20connected%20nodes%20and%20arrows%20forming%20a%20distribution%20network%20on%20a%20warm%20neutral%20surface%2C%20soft%20diffused%20light%2C%20muted%20amber%20and%20stone%20tone%20palette%2C%20abstract%20content%20flow%20theme%2C%20minimal%20clean%20composition%2C%20high%20detail&width=1200&height=675&seq=heiliaoyiqu-story-03&orientation=landscape',
    readTime: '15 分钟深读',
    date: '09.04',
    views: '2.6 万',
  },
];

export const collections = [
  { index: '01', title: '事件复盘合集', count: 46, desc: '把一桩事件的起承转合摊开，按节点逐一还原。' },
  { index: '02', title: '机制拆解合集', count: 38, desc: '拆开节目、平台与分发背后的运行逻辑。' },
  { index: '03', title: '时间线索引', count: 27, desc: '以小时为单位的关键转折点速查表。' },
  { index: '04', title: '多方回应归档', count: 33, desc: '各方公开回应的原文与口径变化记录。' },
  { index: '05', title: '数据对照合集', count: 21, desc: '用可比数据交叉印证说法与事实。' },
];

export const featuredCollection = {
  index: '01',
  title: '事件复盘合集',
  count: 46,
  updated: '今日 12:04 更新',
  desc: '从第一帧画面到第 N 次回应，把每一次转折按时间顺序摆在一起，看清事件是怎么一步步走到今天的。',
  tags: ['时间线', '原文归档', '多方口径'],
};

export const timelineEvent = {
  title: '综艺剪辑争议',
  status: '追踪中 · 第 9 天',
  summary:
    '从片段播出到多方回应，争议的焦点几度转移。以下为已核对的 5 个关键节点，每个节点均附来源出处。',
  nodes: [
    { time: '第 1 天 20:40', title: '片段播出', desc: '节目正片上线，相关片段在 40 分钟内进入热榜。', tag: '起点' },
    { time: '第 2 天 09:12', title: '剪辑质疑出现', desc: '有观众逐帧比对预告与正片，指出画面顺序并不一致。', tag: '发酵' },
    { time: '第 3 天 15:30', title: '节目方首次回应', desc: '以「时长所限」解释调整，未回应具体的顺序问题。', tag: '回应' },
    { time: '第 5 天 11:05', title: '对照素材流出', desc: '更多未播素材被公开，争议焦点转向叙事引导。', tag: '转折' },
    { time: '第 8 天 18:20', title: '机制讨论扩散', desc: '讨论从单期节目扩展到行业剪辑惯例的普遍问题。', tag: '扩散' },
  ],
};

export const timelineStats = [
  { label: '已核对节点', value: '5' },
  { label: '关联合集', value: '3' },
  { label: '社区讨论', value: '1.8k' },
];

export const updateStream = [
  { time: '12:04', tag: '脉络', text: '综艺剪辑争议事件脉络补齐第 5 个节点', source: '深挖组' },
  { time: '11:37', tag: '回应', text: '代言反噬复盘更新品牌方回应时间线', source: '舆情线' },
  { time: '11:02', tag: '分发', text: '搬运链条调查新增 3 条账号路径对照', source: '数据组' },
  { time: '10:26', tag: '数据', text: '关键词追踪：热词「剪辑叙事」搜索量周环比上升', source: '数据组' },
  { time: '09:48', tag: '归档', text: '合集索引「事件复盘」第 46 篇归档完成', source: '索引组' },
  { time: '09:15', tag: '社区', text: '社区新增 128 条讨论，两条热门线索进入复核', source: '社区组' },
  { time: '08:40', tag: '原文', text: '新增一份公开声明原文比对，标注口径变化处', source: '归档组' },
  { time: '08:05', tag: '速查', text: '「时间线索引」补充第 27 条可检索记录', source: '索引组' },
];

export const updateFilters = ['全部', '脉络', '回应', '数据', '社区'];

export const topicGroups = [
  { name: '事件类型', topics: ['节目争议', '品牌合作', '内容分发', '平台规则'] },
  { name: '分析方法', topics: ['时间线复盘', '数据对照', '原文归档', '口径梳理'] },
  { name: '内容形态', topics: ['深度长文', '速查索引', '合集归档', '讨论帖'] },
  { name: '热度标签', topics: ['剪辑叙事', '回应口径', '流量倾斜', '关键词追踪'] },
];

export const communityThreads = [
  {
    title: '同一段素材，两种剪法，观众的情绪完全相反',
    excerpt: '把预告和正片并排放着看，顺序一换，指向就变了。想听听大家怎么看这种「引导式剪辑」。',
    author: '逐帧看客',
    time: '38 分钟前',
    replies: 42,
    likes: 128,
    tag: '讨论',
  },
  {
    title: '整理了一下各方回应的口径变化，欢迎补充',
    excerpt: '从第一次回应到最新一次，措辞改了三次，重点也整体挪了位置，做了一张对照表。',
    author: '归档小工',
    time: '2 小时前',
    replies: 27,
    likes: 96,
    tag: '整理',
  },
  {
    title: '为什么同期内容的流量总是流向同一批账号？',
    excerpt: '观察了两周的热榜，发现分发的节奏有一些可循的规律，抛出来一起拆解一下。',
    author: '数据搬运工',
    time: '5 小时前',
    replies: 63,
    likes: 214,
    tag: '拆解',
  },
];

export const hotBoard = [
  { rank: 1, title: '剪辑叙事与观众判断之间的那条线', heat: '4.8k' },
  { rank: 2, title: '回应口径三次变化的完整对照', heat: '3.6k' },
  { rank: 3, title: '内容分发里被忽略的时间差', heat: '2.9k' },
  { rank: 4, title: '关键词热度曲线上的一处反常', heat: '2.1k' },
  { rank: 5, title: '同源素材的二次加工路径梳理', heat: '1.7k' },
];

export const footerGroups = [
  { name: '内容', links: ['精选深挖', '事件脉络', '实时更新', '合集索引'] },
  { name: '社区', links: ['讨论区', '热议榜', '线索提交', '成员公约'] },
  { name: '关于', links: ['关于我们', '内容准则', '来源与纠错', '联系方式'] },
];

export const footerMeta = '黑料一区 · 深挖解析真相，详细扒内幕细节。本站内容为公开信息整理与观点讨论。';